import React from 'react';
import {
  Box,
  HStack,
  VStack,
  Text,
  Progress,
  ProgressFilledTrack,
} from '@gluestack-ui/themed';
import { useTranslation } from 'react-i18next';

interface QuizProgressProps {
  totalQuestions: number;
  answeredCount: number;
  timeRemaining?: string | null;
}

export const QuizProgress: React.FC<QuizProgressProps> = ({
  totalQuestions,
  answeredCount,
  timeRemaining,
}) => {
  const { t } = useTranslation();
  const progress = (answeredCount / totalQuestions) * 100;

  return (
    <Box
      testID="mcq-progress-indicator"
      bg="$bgCard"
      borderRadius="$lg"
      p="$4"
      mb="$4"
      borderWidth={1}
      borderColor="$borderLight"
    >
      <VStack space="md">
        <HStack justifyContent="space-between" alignItems="center">
          <Text size="sm" bold>
            {answeredCount}
            {' of '}
            {totalQuestions}
            {' answered'}
          </Text>

          {timeRemaining && (
            <Text size="sm" color="$warning600" bold>
              {t('student.mcq.timeRemaining', { time: timeRemaining })}
            </Text>
          )}
        </HStack>

        <Progress value={progress} size="sm">
          <ProgressFilledTrack />
        </Progress>
      </VStack>
    </Box>
  );
};

export default QuizProgress;
